/* eslint-disable */

import {useEffect, useState, useCallback, useRef} from "react";
import MainLayout from "../components/MainLayout";
import {toast} from "react-toastify";
import "moment/locale/uz";
import {useLocation, useNavigate} from "react-router-dom";
import {BreadCrumb} from "primereact/breadcrumb";
import {
	createShipment,
	editShipment,
	getAllStorage,
	getDrivers,
	getSborshiks,
} from "../services/shipment.service";
import CustomerHeaderSection from "../components/shipment/customer/headerSection";
import CustomerTableSection from "../components/shipment/customer/tableSection";
import CustomerSubmitSection from "../components/shipment/customer/submitSection";
import { getBlocksOfStorage } from "../services/block.service";

const ReleaseCustomerPage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const API_BASE = process.env.REACT_APP_BASE_URL;

	const isEditMode = !!location.state?.editData;
	const editData = location.state?.editData;

	// States
	const [furnitureItems, setFurnitureItems] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);
	const [storageBlocks, setStorageBlocks] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedItems, setSelectedItems] = useState([]);
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedOrder, setSelectedOrder] = useState(null);
	const [selectedClientOrders, setSelectedClientOrders] = useState([]);
	const [shipmentDate, setShipmentDate] = useState(new Date());
	const [selectedDrivers, setSelectedDrivers] = useState(null);
	const [selectedCollectors, setSelectedCollectors] = useState([]);
	const [shipmentComment, setShipmentComment] = useState("");
	const [availableClients, setAvailableClients] = useState([]);
	const [availableOrders, setAvailableOrders] = useState([]);
	const [availableDrivers, setAvailableDrivers] = useState([]);
	const [availableCollectors, setAvailableCollectors] = useState([]);
	const [isBlockEditDialogVisible, setIsBlockEditDialogVisible] =
		useState(false);
	const [selectedSerialAmount, setSelectedSerialAmount] = useState();
	const [isCreatingShipment, setIsCreatingShipment] = useState(false);

	// Refs
	const [updateCounter, setUpdateCounter] = useState(0);

	useEffect(() => {
		if (isEditMode && editData.length > 0) {
			const shipmentData = editData[0];
			const furnituresList = shipmentData.furnitures || [];

			if (furnituresList.length > 0) {
				const firstFurniture = furnituresList[0];
				const clientName = firstFurniture.demand?.customer?.name;
				if (clientName) {
					setSelectedClient(clientName);
					setAvailableClients([clientName]);
				}

				if (shipmentData.shipment) {
					if (shipmentData.shipment.date) {
						setShipmentDate(new Date(shipmentData.shipment.date));
					}

					if (shipmentData.shipment.description) {
						setShipmentComment(shipmentData.shipment.description);
					}

					if (shipmentData.shipment.driver?.id) {
						setSelectedDrivers(shipmentData.shipment.driver.id);
					}

					if (
						shipmentData.shipment.sborshiks &&
						Array.isArray(shipmentData.shipment.sborshiks)
					) {
						const sborshikIds = shipmentData.shipment.sborshiks.map(
							(s) => s.id
						);
						setSelectedCollectors(sborshikIds);
					}
				}
			}

			const formattedFurnitures = furnituresList.map((furniture) => ({
				id: furniture.demand_furniture.id,
				unique: {
					name: furniture.unique?.name,
					id: furniture.unique?.id,
				},
				furniture: {
					name: furniture.demand_furniture?.furniture?.name || "N/A",
				},
				amount: furniture.amount || 1,
				shipment_amount: furniture.amount || 1,
				demand: furniture.demand,
				demand_furniture: furniture.demand_furniture,
				fromWhere: "SKLAD",
			}));

			const quantities = {};
			formattedFurnitures.forEach((item) => {
				quantities[item.id] = item.shipment_amount || item.amount || 1;
			});

			setFurnitureItems(formattedFurnitures);
			setFilteredItems(formattedFurnitures);
			setSelectedItems(formattedFurnitures);

			console.log(furnituresList);

			if (furnituresList.length > 0) {
				const orderName = furnituresList[0]?.unique?.name.slice(0, 5) || `-`;
				setSelectedOrder(orderName);
				setAvailableOrders([orderName]);
				setSelectedClientOrders([orderName]);
			}
		}
	}, [isEditMode, editData]);

	// Data Fetching
	const fetchFurnitureData = useCallback(async () => {
		if (isEditMode) return;

		setIsLoading(true);
		try {
			const {uniques} = await getAllStorage();
			const filteredItems = uniques.filter(
				(value) => value.demand_furniture_id !== null
			);

			setFurnitureItems(filteredItems);
			setFilteredItems(filteredItems);

			const getUniqueClientNames = (filteredItems) => {
				const seenDocNos = new Set();
				const clientNames = [];

				for (const item of filteredItems) {
					const docNo = item.demand_furniture?.demand?.doc_no;
					const clientName = item.demand_furniture?.demand?.customer?.name;

					if (docNo && !seenDocNos.has(docNo)) {
						seenDocNos.add(docNo);
						if (clientName) clientNames.push(clientName);
					}
				}

				return clientNames;
			};

			const clientNames = getUniqueClientNames(filteredItems);

			setAvailableClients(clientNames);
		} catch (error) {
			console.error("Failed to fetch furniture data:", error);
			toast.error("Маълумотларни юклашда хатолик юз берди");
		} finally {
			setIsLoading(false);
		}
	}, [API_BASE, isEditMode]);

	const fetchDropdownData = async () => {
		try {
			const [driversRes, collectorsRes] = await Promise.all([
				getDrivers(),
				getSborshiks(),
			]);

			setAvailableDrivers(driversRes);
			setAvailableCollectors(collectorsRes);
		} catch (error) {
			console.error("Failed to fetch dropdown data:", error);
			toast.error("Қўшимча маълумотларни юклашда хатолик");
		}
	};

	const fetchStorageBlocks = useCallback(async () => {
		try {
			const {blocks} = await getBlocksOfStorage();
			setStorageBlocks(blocks);
		} catch (error) {
			console.error("Failed to fetch storage blocks:", error);
			toast.error("Склад маълумотларини юклашда хатолик");
		}
	}, [API_BASE]);

	useEffect(() => {
		fetchFurnitureData();
		fetchDropdownData();
		fetchStorageBlocks();
	}, [fetchFurnitureData, fetchStorageBlocks]);

	useEffect(() => {
		if (isEditMode) return;

		const filtered = furnitureItems.filter((item) => {
			const clientMatch = selectedClient
				? item.demand_furniture?.demand?.customer?.name === selectedClient
				: true;

			const orderMatch = selectedOrder
				? item.unique.name === selectedOrder
				: selectedClient
				? true
				: true;

			return clientMatch && orderMatch;
		});

		setFilteredItems(filtered);
		setSelectedItems(filtered);
	}, [selectedClient, selectedOrder, furnitureItems, isEditMode]);

	// Handlers
	const handleCreateShipment = async () => {
		setIsCreatingShipment(true);
		try {
			if (!selectedDrivers || !shipmentDate) {
				toast.error("Камида битта шафёр ва санани танланг");
				return;
			}

			if (!selectedItems.length) {
				toast.error("Камида битта буюмни танланг");
				return;
			}

			const selectedItemIds = selectedItems.map((item) => item.id);
			console.log(selectedItems);
			console.log(selectedItemIds);

			const localDate = new Date(
				shipmentDate.getFullYear(),
				shipmentDate.getMonth(),
				shipmentDate.getDate(),
				5,
				0,
				0
			);

			const date = new Date(localDate);
			const formatted = date.toISOString().slice(0, 10);

			const selectedItemsIds = selectedItems.map((item) => {
				return {
					id: item.id,
					amount: item.amount,
					unique_id: item.unique.name,
				};
			});

			const shipmentPayload = {
				date: formatted,
				description: shipmentComment,
				driver: {id: selectedDrivers},
				sborshiks: selectedCollectors.map((collector) => {
					return {id: collector};
				}),
				demand_furniture: selectedItemsIds,
			};

			if (isEditMode) {
				const selectedItemDemands = selectedItems.map((item) => {
					return {
						id: item.id,
						amount: item.amount,
						unique_id: item.unique?.id || null,
						closed: item.closed || false,
					};
				});

				const shipmentInfo = editData[0].shipment;
				const editShipmentData = {
					date: formatted,
					description: shipmentComment,
					status: shipmentInfo.status,
					driver: {id: selectedDrivers},
					sborshiks: selectedCollectors.map((collector) => {
						return {id: collector};
					}),
					demand_furniture: selectedItemDemands,
				};

				await editShipment(editData[0].shipment.id, editShipmentData);

				toast.success("Жўнатма муваффақиятли ўзгартирилди");
				navigate(-1);
			} else {
				await createShipment(shipmentPayload);

				setFurnitureItems((prev) =>
					prev.filter((item) => !selectedItemIds.includes(item.id))
				);
				setFilteredItems((prev) =>
					prev.filter((item) => !selectedItemIds.includes(item.id))
				);

				toast.success("Жўнатма муваффақиятли яратилди");
				navigate(`/release`);
				resetForm();
			}
		} catch (error) {
			console.error(error);
			toast.error(
				isEditMode
					? "Жўнатма ўзгартиришда хатолик юз берди"
					: "Жўнатма яратишда хатолик юз берди"
			);
		} finally {
			setIsCreatingShipment(false);
		}
	};

	const resetForm = () => {
		setSelectedItems([]);
		setSelectedClient(null);
		setSelectedOrder(null);
		setSelectedDrivers(null);
		setSelectedCollectors([]);
		setShipmentComment("");
		setShipmentDate(new Date());
	};

	const item = [
		{
			label: "Отгрузкалар",
			template: () => (
				<span className="cursor-pointer" onClick={() => navigate(`/release`)}>
					Отгрузкалар
				</span>
			),
		},
		{
			label: isEditMode ? "Отгрузкани ўзгартириш" : "Мижозга отгрузка қилиш",
			template: () => (
				<span className="font-semibold text-primary">
					{isEditMode ? "Отгрузкани ўзгартириш" : "Мижозга отгрузка қилиш"}
				</span>
			),
		},
	];

	return (
		<MainLayout
			header={isEditMode ? `ОТГРУЗКАНИ ЎЗГАРТИРИШ` : `МИЖОЗГА ОТГРУЗКА ҚИЛИШ`}>
			<div className="mr-1">
				{location.state?.breadCrumb && (
					<BreadCrumb model={item} className="px-0 pt-0 mb-6" />
				)}
				<div className="flex justify-between mb-4">
					<CustomerHeaderSection
						availableClients={availableClients}
						selectedClient={selectedClient}
						setSelectedClient={setSelectedClient}
						availableOrders={availableOrders}
						selectedOrder={selectedOrder}
						selectedClientOrders={selectedClientOrders}
						setSelectedOrder={setSelectedOrder}
						shipmentDate={shipmentDate}
						setShipmentDate={setShipmentDate}
						isLoading={isLoading}
						isEditMode={isEditMode}
						resetForm={resetForm}
						furnitureItems={furnitureItems}
						setAvailableOrders={setAvailableOrders}
						setSelectedClientOrders={setSelectedClientOrders}
					/>
				</div>

				{(selectedClient || isEditMode) && (
					<CustomerTableSection
						filteredItems={filteredItems}
						isLoading={isLoading}
						updateCounter={updateCounter}
						isEditMode={isEditMode}
						selectedSerialAmount={selectedSerialAmount}
						setSelectedSerialAmount={setSelectedSerialAmount}
					/>
				)}

				{(selectedClient || isEditMode) && (
					<CustomerSubmitSection
						availableDrivers={availableDrivers}
						selectedDrivers={selectedDrivers}
						setSelectedDrivers={setSelectedDrivers}
						availableCollectors={availableCollectors}
						selectedCollectors={selectedCollectors}
						setSelectedCollectors={setSelectedCollectors}
						shipmentComment={shipmentComment}
						setShipmentComment={setShipmentComment}
						isEditMode={isEditMode}
						isCreatingShipment={isCreatingShipment}
						handleCreateShipment={handleCreateShipment}
					/>
				)}
			</div>
		</MainLayout>
	);
};

export default ReleaseCustomerPage;
